import PropTypes from "prop-types";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";

import { FilterWrapper, FilterSortSubtitle } from "../../styles";

const SortBy = ({ items, sortBy, onSortChange }) => {
  return (
    <FilterWrapper pb="100px">
      <FilterSortSubtitle>Sort by</FilterSortSubtitle>
      <RadioGroup defaultValue="asc" sx={{ fontWeight: 500 }}>
        {items.map((item) => (
          <FormControlLabel
            checked={sortBy === item.value}
            value={item.value}
            control={<Radio />}
            label={item.text}
            key={`sort-by-${item.key}`}
            onClick={() => onSortChange(item.value)}
          />
        ))}
      </RadioGroup>
    </FilterWrapper>
  );
};

SortBy.propTypes = {
  sortBy: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isRefined: PropTypes.bool,
    }),
  ),
};

export default SortBy;
